import React from 'react'

const ICON = {
    width: "2rem",
    height: "2rem"
};

const IconMenu = ({ opened }) => {

    return(
        opened ?
            <svg width={24} viewBox="0 0 18 18">
                <path
                fill="#fff"
                d="M9 7.586l4.95-4.95 1.414 1.414L10.414 9l4.95 4.95-1.414 1.414L9 10.414l-4.95 4.95-1.414-1.414L7.586 9l-4.95-4.95L4.05 2.636 9 7.586z"
                />
            </svg> :
            <svg width={24} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="white">
                <title>Menu</title>
                <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
    )
}
export default IconMenu;
